import { useUpdateApplication } from '../../../hooks'
import { GenericError } from '../../../utils'
import { AdditionalDocumentsTab } from './AdditionalDocumentsTab'
import { ApplicationFormsProps } from './ApplicationForms'
import { ContactInformationTab } from './ContactInformationTab'
import { EducationHistoryTab } from './EducationHistoryTab'
import { LanguageProficiencyTab } from './LanguageProficiencyTab'
import { LegacyLanguageProficiencyTab } from './LegacyLanguageProficiencyTab'
import { PersonalInformationTab } from './PersonalInformationTab/PersonalInformationTab'
import { useGetTimelineItems } from '../../../hooks/useGetTimelineItems'
import { TimelineTabs } from '../../../utils/enums'
import { hasLegacyLanguageProficiencySchema } from './utils'

export function FormTab(
  props: Omit<ApplicationFormsProps, 'onError'> & {
    onError: (err: GenericError) => void
    updateApplication: ReturnType<typeof useUpdateApplication>['updateApplication']
    formId: string
  },
) {
  const timelineItems = useGetTimelineItems(props.application)
  const timelineItem = timelineItems.find(item => item.key === props.selectedTab)

  const { applicationHasLegacyLanguageProficiency } = hasLegacyLanguageProficiencySchema(
    props.application,
  )

  switch (timelineItem?.key) {
    case TimelineTabs.OTHER_REQUIRED_DOCUMENTS:
      return (
        <AdditionalDocumentsTab
          selectedTab={props.selectedTab}
          application={props.application}
          onSuccess={props.onSuccess}
          onError={props.onError}
          submitApplication={props.submitApplication}
          disabled={props.disabled}
          updateApplication={props.updateApplication}
          formId={props.formId}
        />
      )
    case TimelineTabs.LANGUAGE_PROFICIENCY:
      return applicationHasLegacyLanguageProficiency ? (
        <LegacyLanguageProficiencyTab
          onSuccess={props.onSuccess}
          application={props.application}
          onError={props.onError}
          disabled={props.disabled}
          updateApplication={props.updateApplication}
          formId={props.formId}
        />
      ) : (
        <LanguageProficiencyTab
          onSuccess={props.onSuccess}
          application={props.application}
          onError={props.onError}
          disabled={props.disabled}
          updateApplication={props.updateApplication}
          formId={props.formId}
        />
      )
    case TimelineTabs.EDUCATION_HISTORY:
      return (
        <EducationHistoryTab
          onSuccess={props.onSuccess}
          application={props.application}
          onError={props.onError}
          disabled={props.disabled}
          updateApplication={props.updateApplication}
          formId={props.formId}
        />
      )
    case TimelineTabs.CONTACT_INFORMATION:
      return (
        <ContactInformationTab
          onSuccess={props.onSuccess}
          application={props.application}
          onError={props.onError}
          disabled={props.disabled}
          updateApplication={props.updateApplication}
          formId={props.formId}
        />
      )
    default:
      return (
        <PersonalInformationTab
          onSuccess={props.onSuccess}
          application={props.application}
          onError={props.onError}
          disabled={props.disabled}
          updateApplication={props.updateApplication}
          formId={props.formId}
        />
      )
  }
}
